import { useCallback, useState } from 'react';
import { useLogin } from 'state/base/hooks';
import Server from 'utils/serviceApi';
const useBalance = (): [number, (coin: string, contract: string, user?: string) => Promise<any>, boolean] => {
    const [userInfo] = useLogin();
    const [loadding, setLoadding] = useState<boolean>(false);
    const [balance, setBalance] = useState<number>(0);

    const getBalance = useCallback(
        async (coin: string, contract: string, user?: string) => {
            try {
                setLoadding(true);
                user = user ?? userInfo.name;
                const result: any = await Server.getBalanceByUser(userInfo.name, coin, contract);
                let balance = 0;
                if (result.length > 0) {
                    balance = result[0].split(' ')[0] ?? 0;
                }
                setBalance(Number(balance))
                return balance;
            } catch (e) {
            } finally {
                setLoadding(false);
            }
        },
        [userInfo.name]
    );

    return [balance, getBalance, loadding];
};

export default useBalance;
